import { Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { RktIconComponent } from '@rocketfinancialcorp/rocket-ui/icon';
import { Breadcrumb } from '@shared/models';

@Component({
  selector: 'app-breadcrumbs',
  standalone: true,
  templateUrl: './breadcrumbs.component.html',
  imports: [RktIconComponent, RouterLink],
})
export class BreadcrumbsComponent {
  @Input() breadcrumbs?: Breadcrumb[] = [];
}
